import { opsManagementApi } from '@/features/admin/api/opsManagementApi';
import type { StationSensorAlertRuleRow } from '@/features/admin/types/opsExtended.types';
import { store } from '@/stores';

export const ALERT_THRESHOLDS_PAGE_SIZE = 500;

let sharedCacheKey = -1;
let sharedCache: StationSensorAlertRuleRow[] | null = null;
let sharedInflightKey = -1;
let sharedInflight: Promise<StationSensorAlertRuleRow[]> | null = null;

/** Xóa cache dùng chung (hiếm khi cần — thường đổi `reloadKey` là đủ). */
export function invalidateSharedAlertThresholdRowsCache(): void {
  sharedCacheKey = -1;
  sharedCache = null;
  sharedInflightKey = -1;
  sharedInflight = null;
}

async function fetchAllPagesFromApi(): Promise<StationSensorAlertRuleRow[]> {
  const all: StationSensorAlertRuleRow[] = [];
  let page = 1;
  for (;;) {
    const paged = await store
      .dispatch(
        opsManagementApi.endpoints.getAlertThresholds.initiate(
          { page, pageSize: ALERT_THRESHOLDS_PAGE_SIZE },
          { subscribe: false },
        ),
      )
      .unwrap();
    all.push(...paged.items);
    const total = paged.total ?? all.length;
    if (all.length >= total || paged.items.length < ALERT_THRESHOLDS_PAGE_SIZE) break;
    page += 1;
  }
  return all;
}

/**
 * Lấy toàn bộ rule ngưỡng — một request đồng thời cho mọi `useDashboardIoTStations`.
 * `reloadKey` thường là `fulfilledTimeStamp` của trang 1 sau invalidate admin.
 */
export function fetchAllAlertThresholdRowsShared(
  reloadKey: number,
): Promise<StationSensorAlertRuleRow[]> {
  if (sharedCache && sharedCacheKey === reloadKey) {
    return Promise.resolve(sharedCache);
  }
  if (sharedInflight && sharedInflightKey === reloadKey) {
    return sharedInflight;
  }
  sharedInflightKey = reloadKey;
  sharedInflight = fetchAllPagesFromApi()
    .then((rows) => {
      sharedCache = rows;
      sharedCacheKey = reloadKey;
      sharedInflight = null;
      return rows;
    })
    .catch((err) => {
      sharedInflight = null;
      throw err;
    });
  return sharedInflight;
}
